import axios from 'axios'

export default {
    namespaced: true,
    state: {
        user: null,
        users: [],
        authError : false
    },
    mutations: {
        SET_AUTH_USER(state, user){
            state.user = user
        },
        SET_AUTH_ERROR(state, flag){
            state.authError = flag
        },
        GET_USERS(state, payload){
            state.users = payload
        },
    },
    actions: {
        login({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                axios.post('/auth/login', credentials)
                .then(res => {
                    //TODO only for test
                    //res.data.permissions = ['message-list', 'free-list']
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        register(state, form) {
            return new Promise((resolve, reject) => {
                axios.post('register', form)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        clients({ commit, getters}) {
            return new Promise((resolve, reject) => {
                axios.get('client')
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        users({ commit, getters }) {
            return new Promise((resolve, reject) => {
                axios.get('user')
                .then(res => {
                    commit('GET_USERS', res.data.data)
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        store({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                axios.post('user', formData)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        update({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                axios.put(`user/${formData._id}`, formData)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        show({ commit, getters }, userId) {
            return new Promise((resolve, reject) => {
                axios.get(`user/${userId}`)
                  .then(res => {
                      resolve(res.data)
                  })
                  .catch(error => {
                      reject(error.response.data)
                  })
            })
        },
        destroy({ commit, getters }, id) {
            return new Promise((resolve, reject) => {
                axios.delete(`user/${id}`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        showUserBalance({ commit, getters }, {userId, currencyId}) {
            return new Promise((resolve, reject) => {
                axios.get(`customer/${userId}/${currencyId}/balance`)
                  .then(res => {
                      resolve(res.data)
                  })
                  .catch(error => {
                      reject(error.response.data)
                  })
            })
        },
        showAllUserBalance({ commit, getters }, {userId}) {
            return new Promise((resolve, reject) => {
                axios.get(`customer/${userId}/balance`)
                    .then(res => {
                        resolve(res.data)
                    })
                    .catch(error => {
                        reject(error.response.data)
                    })
            })
        },
    }
}